module.exports = __webpack_public_path__ + "static/media/video.8daecb5d.png";